<div class="mt-4">
  <div>
    <div class="d-flex justify-content-between mb-4 align-items-center px-4">
      <div style="text-align-last: left">
        <i
          (click)="dismiss()"
          class="fa fa-times"
          aria-hidden="true"
          style="cursor: pointer; color: #555770"
        ></i>
      </div>
    </div>

    <div class="disclaimer">
      <h4 class="text-center mb-5">الاحكام والشروط لدخول الأسلحة</h4>


      <div class="mx-5">
        <ul>
          <li>يجب ابراز الهوية الوطنية الأصل او عن طريق برنامج ابشر او توكلنا اثناء تسليم الأسلحة ودخولها للميدان، ولا تقبل صور.</li>
          <li>يجب ان يكون السلاح مصرح والرخصة سارية المفعول.</li>
          <li>يجب إصدار تصريح نقل السلاح "للأسلحة الاقتناء" من منصة ابشر قبل التوجه للميدان وتكون وجهة النقل الى مستودعات نادي الصقور، ولا يسمح بدخول أي سلاح بدون رخصة نقل سارية المفعول، ولا يلزم التصريح لأسلحة الحمل.</li>
          <li>لا يسمح باستخدام السلاح لغير صاحبة، حسب تعليمات وزارة الداخلية.</li>
          <li>يسمح بدخول الأسلحة بعيار ال ٩ ملم و الشوزن عيار G12 ولا يسمح بدخول أي عيارات أخرى.</li>
          <li>يمنع منعا باتا دخول أي ذخيرة من خارج الميدان.</li>
          <li>يجب التأكد من عدم تذخير الأسلحة وقت الدخول للميدان والخروج منه.</li>
          <li>تستلم الأسلحة على حالتها الجاهزة للاستخدام (مركبة).</li>
          <li>يمنع التنقل دخال الميدان بالأسلحة الشخصية ويتم تسليمها للرامي في منصة الرماية فقط.</li>
          <li>تسلم الأسلحة بعد الانتهاء من الرماية في نفس منصة التسليم ببيان الاستلام والتوقيع عليه ويتم استلامها عند بوابة خروج الأسلحة.</li>
          <li>لا ينصح بإدخال الاكسسوارات عير مخازن السلاح، وفي حال دخولها تخلى مسؤولية ميادين عنها.</li>
          <li>يجب ان يكون السلاح في حقيبة قابلة للقفل، او يتم استخدام الحقائب المخصصة من قبل ميادين.</li>
          <li>ميادين غير مسؤولة عن أي خدوش بالأسلحة أو اعطال سواء كانت بالسلاح قبل او خلال وجودها في الميدان.</li>
          <li>في حال فقدان مفتاح القفل يتحمل العميل غرامة 100 ريال.</li>
          <li>لا تقبل التفاويض او الوكالة على الأسلحة.</li>
          <li>يقر مالك السلاح بالموافقة على الشروط والاحكام بمجرد رفع الطلب.</li>
        </ul>
      </div>
    </div>


    <div class="text-center">
      <button
        (click)="agreedClicked()"
        type="submit"
        class="btn btn-primary width-adjust login-btn mb-3"
      >
        {{ "Agree to Access Weapons" | translate }}
      </button>
    </div>
  </div>
</div>




